var validate = require('validate.js');
import smoothscroll from 'smoothscroll-polyfill';
import { debounce, getOffsetTop } from './utils';

smoothscroll.polyfill();

(function () {
  // Before using it we must add the parse and format functions
  // Here is a sample implementation using moment.js
  //   validate.extend(validate.validators.datetime, {
  //     // The value is guaranteed not to be null or undefined but otherwise it
  //     // could be anything.
  //     parse: function (value, options) {
  //       return +moment.utc(value);
  //     },
  //     // Input is a unix timestamp
  //     format: function (value, options) {
  //       var format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
  //       return moment.utc(value).format(format);
  //     },
  //   });

  // These are the constraints used to validate the form
  var log = false;

  var constraints = {
    name: {
      presence: {
        message: getMessage('name', 'presence'),
      },
    },
    phone: {
      presence: {
        message: getMessage('name', 'presence'),
      },
    },
    email: {
      presence: {
        message: getMessage('email', 'presence'),
      },
      email: {
        message: getMessage('email', 'email'),
      },
    },
  };

  var forms = document.querySelectorAll('form.contact-form');
  for (var j = 0; j < forms.length; j++) {
    var form = forms[j];

    var prefix = form.id;
    if (prefix.indexOf('contact-form') === 0) {
      log && console.log('form:init', prefix);
      var form = document.querySelector('form#' + prefix);
      form.addEventListener('submit', (event) => {
        log && console.log('form:submit fired');
        handleFormSubmit(event, form, prefix);
      });

      // Hook up the inputs to validate on the fly
      var inputs = document.querySelectorAll('input, textarea, select');
      for (var i = 0; i < inputs.length; ++i) {
        inputs.item(i).addEventListener('change', (event) => {
          log && console.log('input:change');
          var input = event.target;
          var errors;
          if (prefix) {
            errors = validate(form, prefixConstraints(constraints, prefix)) || {};
          } else {
            errors = validate(form, constraints) || {};
          }
          showErrorsForInput(input, errors[input.name]);
        });
      }
    }
  }

  // Hook up the form so we can prevent it from being posted

  function getMessage(field, validator) {
    if (typeof enquiryForm !== 'undefined' && enquiryForm[field] && enquiryForm[field][validator]) {
      return '^' + enquiryForm[field][validator];
    } else {
      return 'Field ' + field + ' did not pass ' + validator + ' validation.';
    }
  }

  function handleFormSubmit(event, form, prefix) {
    // validate the form against the constraints
    var errors;
    if (prefix) {
      errors = validate(form, prefixConstraints(constraints, prefix));
    } else {
      errors = validate(form, constraints);
    }
    // then we update the form to reflect the results
    if (!errors) {
      log && console.log('form:disable');
      disableForm(form);
      log && console.log('form:pass through');
    } else {
      log && console.log('form:prevent default');
      event.preventDefault();
      log && console.log('form:show errors');
      showErrors(form, errors || {});
      log && console.log('errors:cought', errors);
      window.scrollTo({
        top: (form.querySelector('.has-error') ? getOffsetTop(form.querySelector('.has-error')) : getOffsetTop(form)) - document.querySelector('.js-main-navbar').offsetHeight - 12,
        behavior: 'smooth',
      });
    }
  }

  function prefixConstraints(constraints, prefix) {
    var constraintsWithPrefix = {};
    for (var key in constraints) {
      if (!constraints.hasOwnProperty(key)) continue;
      constraintsWithPrefix['tx_form_formframework[' + prefix + '][' + key + ']'] = constraints[key];
      //   constraintsWithPrefix[prefix + '-' + key] = constraints[key];
    }
    return constraintsWithPrefix;
  }

  // Updates the inputs with the validation errors
  function showErrors(form, errors) {
    // We loop through all the inputs and show the errors for that input
    var inputs = form.querySelectorAll('input[name], select[name]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      showErrorsForInput(input, errors && errors[input.name]);
    }
    // _.each(form.querySelectorAll('input[name], select[name]'), function (input) {
    //   // Since the errors can be null if no errors were found we need to handle
    //   // that
    //   showErrorsForInput(input, errors && errors[input.name]);
    // });
  }

  // Shows the errors for a specific input
  function showErrorsForInput(input, errors) {
    // This is the root of the input
    var formGroup = closestParent(input.parentNode, 'form-group');
    // Find where the error messages will be insert into
    // First we remove any old messages and resets the classes
    if (!formGroup) {
      return 0;
    }
    resetFormGroup(formGroup);
    // If we have errors
    if (errors) {
      var messages = formGroup.querySelector('.messages');
      // we first mark the group has having errors
      formGroup.classList.add('has-error');
      // then we append all the errors
      for (var i = 0; i < errors.length; i++) {
        var error = errors[i];
        addError(messages, error);
      }
      //   _.each(errors, function (error) {
      //     addError(messages, error);
      //   });
    } else {
      // otherwise we simply mark it as success
      formGroup.classList.add('has-success');
    }
  }

  // Recusively finds the closest parent that has the specified class
  function closestParent(child, className) {
    if (!child || child == document) {
      return null;
    }
    if (child.classList.contains(className)) {
      return child;
    } else {
      return closestParent(child.parentNode, className);
    }
  }

  function resetFormGroup(formGroup) {
    // Remove the success and error classes
    formGroup.classList.remove('has-error');
    formGroup.classList.remove('has-success');
    // and remove any old messages
    var elements = formGroup.querySelectorAll('.help-block.error');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      el.parentNode.removeChild(el);
    }
    // _.each(formGroup.querySelectorAll('.help-block.error'), function (el) {
    //   el.parentNode.removeChild(el);
    // });
  }

  // Adds the specified error with the following markup
  // <p class="help-block error">[message]</p>
  function addError(messages, error) {
    var block = document.createElement('p');
    block.classList.add('help-block');
    block.classList.add('error');
    block.innerText = error;
    messages.appendChild(block);
  }
  function submitForm(form) {
    form.submit();
  }
  function disableForm(form) {
    var overlay = form.querySelector('.loading-overlay');
    overlay.classList.remove('hidden');
    var button = form.querySelector('button[type=submit]');
    button.innerText = button.dataset && button.dataset.loadingLabel ? button.dataset.loadingLabel : button.innerText;
  }
})();
